import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import DashboardStatsGrid from "../components/DashboardStatsGrid";
import { Table, Space, Image, Input, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import LoadingScreen from "../lib/constants/loadingScreen";
import debounce from "lodash/debounce";
import { MdDelete, MdEditSquare } from "react-icons/md";

const ViewStaff = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [details, setDetails] = useState([]);
  const [filteredDetails, setFilteredDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [actionLoading, setactionLoading] = useState(false);

  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("adminticket"),
    },
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`${apiBaseUrl}/viewdoctorsadmin`, config)
      .then((response) => {
        if (response.data.success) {
          setDetails(response.data.data);
          setFilteredDetails(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch doctors data:", err);
        toast.error("Failed to get doctors details! Please try again.", {
          position: "bottom-right",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteDoctor = (doctor_id) => {
    if (window.confirm("Are you sure want to delete this doctor's details?")) {
      setactionLoading(true);
      axios
        .delete(`${apiBaseUrl}/doctor/delete/${doctor_id}`, config)
        .then((result) => {
          if (result.data.success) {
            toast.success("Success deletion", {
              position: "bottom-right",
            });
            window.location.reload();
          } else {
            toast.error("Failed to delete", {
              position: "bottom-right",
            });
          }
        })
        .catch((err) => {
          console.error("Failed to delete doctor details", err);
          toast.error(
            "Failed to delete doctor details! Please try again later.",
            {
              position: "bottom-right",
            }
          );
        })
        .finally(() => {
          setactionLoading(false);
        });
    }
  };

  const filteredDoctors = useCallback(
    debounce((searchTerm) => {
      if (searchTerm.trim() !== "") {
        const filtered = details.filter(
          (doctor) =>
            doctor?.fullname.toLowerCase().includes(searchTerm.toLowerCase()) ||
            doctor?.department?.department
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            doctor?.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            doctor?.phone.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredDetails(filtered);
      } else {
        fetchData();
      }
    }, 500),
    [searchTerm, details]
  );

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
    filteredDoctors(searchTerm);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "picture",
      key: "picture",
      render: (picture) => (
        <Image
          src={picture}
          width={80}
          height={80}
          className="object-contain rounded-md"
        />
      ),
    },
    {
      title: "Full Name",
      dataIndex: "fullname",
      width: 180,
      key: "fullname",
    },
    {
      title: "Department",
      dataIndex: ["department", "department"],
      key: "department",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Password",
      render: (_, record) => (
        <Link
          to={`/dashboard/reset/password/${record._id}`}
          className="text-indigo-600 hover:text-indigo-900"
        >
          <button className="text-center">
            <span className="text-sky-600">
              <MdEditSquare size={21} />
            </span>
          </button>
        </Link>
      ),
    },
    {
      title: "Consult Fee",
      dataIndex: "consultFee",
      key: "consultFee",
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Link
            to={`/dashboard/update/doctor/${record._id}`}
            className="text-indigo-600 hover:text-indigo-900"
          >
            <button className="px-4 py-2 ms-2 rounded-md bg-sky-600 text-white hover:bg-sky-700">
              <MdEditSquare />
            </button>
          </Link>
          <Link
            onClick={() => {
              deleteDoctor(record._id);
            }}
            className="text-indigo-600 hover:text-indigo-900"
          >
            <button className="px-4 py-2 ms-2 rounded-md bg-red-700 text-white hover:bg-red-800">
              <MdDelete />
            </button>
          </Link>
        </>
      ),
    },
  ];
  return (
    <>
      {actionLoading && <LoadingScreen />}
      <DashboardStatsGrid />

      <div className="container max-w-8xl mx-auto mt-8" id="viewStaff">
        <div className="mb-4">
          <h1 className="text-3xl font-bold decoration-gray-400">Doctors</h1>
          <div className="flex justify-between mt-2">
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              allowClear
              value={searchTerm}
              onChange={handleSearch}
              style={{ width: 300 }}
            />
            <div>
              <Link to="/dashboard/doctoradd">
                <button className="px-4 py-2 rounded-md bg-sky-600 text-white hover:bg-sky-700">
                  Add Doctor
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <Table
            className="rounded-md shadow-md"
            dataSource={filteredDetails}
            columns={columns}
            rowKey="_id"
            pagination={{
              className: "pe-3",
              defaultPageSize: 15,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            loading={{
              indicator: <Spin size="large" />,
              spinning: loading,
            }}
          />
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
export default ViewStaff;
